<template>
  <div class="pa-2">
    <div v-if="shippingAddress && shippingAddress.length">
      <div v-for="(address, addressIndex) in shippingAddress" :key="addressIndex">
        <ShippingAddressItem :address="address" @onRefetch="() => handleFetchShippingAddress()" />
      </div>
    </div>

    <div v-if="isLoading" class="text-xs-center pa-4">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <div
      v-else-if="!shippingAddress || (shippingAddress && shippingAddress.length == 0)"
      class="text-xs-center pt-3"
    >
      <h1>ไม่พบข้อมูล</h1>
    </div>
  </div>
</template>

<script>
import tremendousApi from '@/api/tremendous'
import { mapGetters } from 'vuex'
import ShippingAddressItem from './ShippingAddressItem'

export default {
  components: {
    ShippingAddressItem
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    pageid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: true,
      shippingAddress: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },

  async mounted() {
    this.handleFetchShippingAddress()
  },
  methods: {
    async handleFetchShippingAddress() {
      const vm = this
      try {
        if (!vm.pageid || !vm.value) {
          return
        }

        vm.isLoading = true

        const params = {
          limit: 100,
          offset: 0,
          user_id: vm.value,
          page_id: vm.pageid
        }

        const response = await tremendousApi.getShippingAddress({ params })

        if (response && response.status === 200) {
          vm.shippingAddress = response.data.data || []
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/ShippingAddress.vue